export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9243.8f13c82b.jpg";